import {
  defaultMapCenter,
  defaultMapMinZoom,
} from 'components/MapComponent/constants';
import React, { useContext, useEffect, useRef } from 'react';
import MapContext from 'components/MapComponent/MapContext';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { setPointsAction } from 'store/actions/searchTab';
import { mainPageSlice } from 'store/reducers/mainPage';

export const AllClusterHandler: React.FC = () => {
  const { map } = useContext(MapContext);
  const { allFoundPoints } = useAppSelector((state) => state.searchTab);
  const lastMinZoom = useRef<number>(-1);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!map || !allFoundPoints.length) return;

    const onMoveEnd = () => {
      const zoom = map.getView().getZoom();

      const clusters = allFoundPoints.find(
        (item) => item.z_level_min <= zoom && zoom < item.z_level_max
      );

      let newZoom = -1;

      if (clusters) {
        newZoom = clusters.z_level_min;
      }

      if (clusters && lastMinZoom.current !== newZoom) {
        const points: any = clusters.items;
        if (points.length) {
          dispatch(mainPageSlice.actions.setBackdropLoading(true));
          setTimeout(() => {
            dispatch(setPointsAction(points));
          }, 300);
        }

        lastMinZoom.current = newZoom;
      }
    };

    map.getView().setZoom(defaultMapMinZoom); //set default zoom after finding clusters
    map.getView().setCenter(defaultMapCenter);

    map.on('moveend', onMoveEnd);
    onMoveEnd();

    return () => {
      map.un('moveend', onMoveEnd);
      lastMinZoom.current = -1;
    };
  }, [map, allFoundPoints]);

  return null;
};
